export default function TextInputLabel({labelName,inputName,defaultValue,onChangeFn,maxLen}){
  return(
    <>
      <label>{labelName}</label>
      <input type='text' defaultValue={defaultValue} name={inputName} onChange={onChangeFn} maxLength={maxLen}/>
    </>
  )
}